/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Reference_HeadingInputs */

const en_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request, response and price`)
};

const zh_hans1_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求、响应和价格`)
};

const pt_br2_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requisição, resposta e preço`)
};

const es_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitud, respuesta y precio`)
};

const fr_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requête, réponse et prix`)
};

const de_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage, Antwort und Preis`)
};

const ru_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрос, ответ и цена`)
};

const it_app_endpoint_reference_heading = /** @type {(inputs: App_Endpoint_Reference_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiesta, risposta e prezzo`)
};

/**
* | output |
* | --- |
* | "Request, response and price" |
*
* @param {App_Endpoint_Reference_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_reference_heading = /** @type {((inputs?: App_Endpoint_Reference_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Reference_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_reference_heading(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_reference_heading(inputs)
	if (locale === "es") return es_app_endpoint_reference_heading(inputs)
	if (locale === "fr") return fr_app_endpoint_reference_heading(inputs)
	if (locale === "de") return de_app_endpoint_reference_heading(inputs)
	if (locale === "ru") return ru_app_endpoint_reference_heading(inputs)
	if (locale === "it") return it_app_endpoint_reference_heading(inputs)
	return en_app_endpoint_reference_heading(inputs)
});